
var windowHeight = $(window).height();
var headerHeight = $('.header').height();
var startScrollPosition = $(window).scrollTop();

$(window).resize(function(){
    windowHeight = $(window).height();
    headerHeight = $('.header').height();
    startScrollPosition = $(window).scrollTop();
});

if (startScrollPosition = 0) {
    /* gdyby chcieli na pierwszego scrolla myszą lub swipe lub keydown - tu dopisać */
}

$('.intro--opener').bind('click', function(){
    isScrolling = true;
    
    $('html,body').animate({
        scrollTop: windowHeight - headerHeight  },
        1200, 'easeInOutExpo', function(){ isScrolling = false; }
    );
    
});